import { TwoColumnBox } from "Components/TwoColumnBox";
import { TestStatus } from "./TestStatus";
import { EnglishProficiencyTest } from "./EnglishProficiency";
import { Flex, Form } from "antd";
import { AptitudeTest } from "./AptitudeTest";
import { useState } from "react";

const bachelorTestOptions = [
  {
    title: "SAT",
  },
  {
    title: "ACT",
  },
  {
    title: "None",
  },
];

const mastersTestOptions = [
  {
    title: "GRE",
  },
  {
    title: "None",
  },
];

export const TestScores = ({ form }) => {
  const [state, setState] = useState({
    testStatus: form.getFieldValue("testStatus"),
    englishTestSelected: form.getFieldValue("englishTestSelected"),
    englishTestScores: form.getFieldValue("englishTestScores") || {},
    aptitudeTestName: form.getFieldValue("aptitudeTestName"),
    greVerbalScore: form.getFieldValue("greVerbalScore"),
    greQuantScore: form.getFieldValue("greQuantScore"),
    greAWAScore: form.getFieldValue("greAWAScore"),
    actTotalScore: form.getFieldValue("actTotalScore"),
    satReadWriteScore: form.getFieldValue("satReadWriteScore"),
    satMathScore: form.getFieldValue("satMathScore"),
  });

  return (
    <TwoColumnBox
      leftElement={
        <Flex vertical>
          <Form.Item
            name="testStatus"
            rules={[{ required: true, message: "Please select a test status" }]}
          >
            <TestStatus
              selectedCard={state.testStatus}
              setSelectedCard={(value) => {
                setState((prev) => {
                  return { ...prev, testStatus: value };
                });
                form.setFieldsValue({ testStatus: value });
              }}
            />
          </Form.Item>
          <Form.Item
            name="englishTestSelected"
            rules={[
              { required: true, message: "Please select an english test" },
              {
                validator: async (_, selected) => {
                  if (!selected) return Promise.resolve();

                  const { englishTestScores } = form.getFieldsValue([
                    "englishTestScores",
                  ]);

                  const hasAnyScore =
                    englishTestScores &&
                    Object.values(englishTestScores).some(
                      (v) => v !== undefined && v !== null && v !== "",
                    );

                  if (hasAnyScore) return Promise.resolve();

                  return Promise.reject(
                    new Error(
                      "Enter at least one English proficiency score to continue.",
                    ),
                  );
                },
              },
            ]}
          >
            <EnglishProficiencyTest
              selectedCard={state.englishTestSelected}
              setSelectedCard={(value) => {
                setState((prev) => ({ ...prev, englishTestSelected: value }));
                form.setFieldsValue({ englishTestSelected: value });
              }}
              scores={state.englishTestScores}
              setScores={(updater) => {
                setState((prev) => {
                  const nextScores =
                    typeof updater === "function"
                      ? updater(prev.englishTestScores || {})
                      : updater;

                  form.setFieldsValue({ englishTestScores: nextScores });
                  return { ...prev, englishTestScores: nextScores };
                });
              }}
            />
          </Form.Item>
        </Flex>
      }
      rightElement={
        <Form.Item
          name="aptitudeTestName"
          rules={[
            { required: true, message: "Please select a aptitude test" },
            {
              validator: (_, value) => {
                if (
                  value === "GRE" &&
                  (!state.greVerbalScore ||
                    !state.greQuantScore ||
                    !state.greAWAScore)
                ) {
                  return Promise.reject(
                    new Error("Please fill in all the GRE scores"),
                  );
                }
                if (
                  value === "SAT" &&
                  (!state.satReadWriteScore || !state.satMathScore)
                ) {
                  return Promise.reject(
                    new Error("Please fill in all the SAT scores"),
                  );
                }
                if (value === "ACT" && !state.actTotalScore) {
                  return Promise.reject(
                    new Error("Please fill in all the ACT scores"),
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <AptitudeTest
            options={
              form.getFieldValue("applyingProgram") === "Bachelors"
                ? bachelorTestOptions
                : mastersTestOptions
            }
            selectedCard={state.aptitudeTestName}
            setSelectedCard={(value) => {
              setState((prev) => {
                return { ...prev, aptitudeTestName: value };
              });
              form.setFieldsValue({ aptitudeTestName: value });
            }}
            greVerbalScore={state.greVerbalScore}
            setGreVerbalScore={(value) => {
              setState((prev) => {
                return { ...prev, greVerbalScore: value };
              });
              form.setFieldsValue({ greVerbalScore: value });
            }}
            greQuantScore={state.greQuantScore}
            setGreQuantScore={(value) => {
              setState((prev) => {
                return { ...prev, greQuantScore: value };
              });
              form.setFieldsValue({ greQuantScore: value });
            }}
            greAWAScore={state.greAWAScore}
            setGreAWAScore={(value) => {
              setState((prev) => {
                return { ...prev, greAWAScore: value };
              });
              form.setFieldsValue({ greAWAScore: value });
            }}
            satReadWriteScore={state.satReadWriteScore}
            setSatReadWriteScore={(value) => {
              setState((prev) => {
                return { ...prev, satReadWriteScore: value };
              });
              form.setFieldsValue({ satReadWriteScore: value });
            }}
            satMathScore={state.satMathScore}
            setSatMathScore={(value) => {
              setState((prev) => {
                return { ...prev, satMathScore: value };
              });
              form.setFieldsValue({ satMathScore: value });
            }}
            actTotalScore={state.actTotalScore}
            setactTotalScore={(value) => {
              setState((prev) => {
                return { ...prev, actTotalScore: value };
              });
              form.setFieldsValue({ actTotalScore: value });
            }}
          />
        </Form.Item>
      }
    />
  );
};
